module.exports = __webpack_public_path__ + "img/although.be5030ca.webp";